import { bl_cms_calendar_event_participant_link_RowClass } from '../../../dbschema/bl_cms_calendar_event_participant_link.model';
import {BaseContainerModel} from '../../base-container.model';

export class CmsEventParticipantLinkContainerModel extends BaseContainerModel{
    bl_cms_calendar_event_participant_link: bl_cms_calendar_event_participant_link_RowClass = new bl_cms_calendar_event_participant_link_RowClass();
}